import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

const DOWNLOADS = [
  { year: "2024", statewideHref: "https://arcg.is/0HL4n51", top100: "https://arcg.is/Oq0ea" },
  { year: "2023", statewideHref: "https://arcg.is/1C0bTa1", top100: "https://arcg.is/1KeGOj2" },
  { year: "2022", statewideHref: "https://arcg.is/1SzPD1",  top100: "" },
  { year: "2021", statewideHref: "https://arcg.is/0TnC0j",  top100: "" },
  { year: "2020", statewideHref: "https://arcg.is/0TrzSO",  top100: "" },
  { year: "2019", statewideHref: "https://arcg.is/1uzHvq0", top100: "" },
  { year: "2018", statewideHref: "https://arcg.is/1e0e40",  top100: "" },
];

const DownloadCell = ({ href, label }) =>
  href ? (
    <Link href={href} target="_blank" rel="noopener">
      {label}
    </Link>
  ) : (
    <Typography variant="body2" color="text.disabled">
      Currently unavailable
    </Typography>
  );

export default function ShapefileDownloadDialog(props) {
  const { shapefileDownloadOpen, setShapefileDownloadOpen } = props;

  const handleClose = () => setShapefileDownloadOpen(false);

  return (
    <Dialog
      open={shapefileDownloadOpen}
      onClose={handleClose}
      key="shapefileDownload"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Downloads</DialogTitle>

      <DialogContentText sx={{ px: 3, pb: 1 }}>
        The data behind MRPT can be downloaded using the following links.
      </DialogContentText>

      <DialogContent sx={{ pt: 0 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>Year</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Statewide Shapefile</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Top 100</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {DOWNLOADS.map(({ year, statewideHref, top100 }) => (
              <TableRow key={year} hover>
                <TableCell>{year}</TableCell>
                <TableCell>
                  <DownloadCell href={statewideHref} label={`${year} Statewide`} />
                </TableCell>
                <TableCell>
                  <DownloadCell href={top100} label={`${year} Top 100`} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}